import { Form } from "@/organisms/Form/Form"
import { ListField } from "@/organisms/Form/components/ListField"
import { FieldSpecificResource } from "./FieldSpecificResource"

import type { SpecificResourcesProps } from ".."

export const SpecificResources = (props: SpecificResourcesProps) => {
  const fieldName = "specific_resources"
  const values = Form.useWatch(fieldName, props.form) || []
  const isValueUsed = values.reduce(
    (acc: Record<string, boolean>, value?: { type: string }) => {
      if (value) acc[value.type] = true

      return acc
    },
    {}
  )

  const { options = [], form, onlyOne, ...rest } = props

  const nextOptions = options.map((option: any) => ({
    disabled: isValueUsed[option.value],
    ...option
  }))
  const buttonProps = {
    size: "small",
    type: "and",
    disabled: values.length === options.length
  } as const
  const last = values.length === 1

  return (
    <ListField
      form={form}
      name={fieldName}
      buttonProps={!onlyOne && buttonProps}
      componentProps={{ last, options: nextOptions, ...rest }}
      render={FieldSpecificResource}
    />
  )
}
